import { render, staticRenderFns } from "./DocModal.vue?vue&type=template&id=0d52b6f8&scoped=true"
import script from "./DocModal.vue?vue&type=script&lang=js"
export * from "./DocModal.vue?vue&type=script&lang=js"
import style0 from "./DocModal.vue?vue&type=style&index=0&id=0d52b6f8&prod&lang=scss&scoped=true"
import style1 from "./DocModal.vue?vue&type=style&index=1&id=0d52b6f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52b6f8",
  null
  
)

export default component.exports